import { FC } from 'react';
import { ImageContent } from '../types';

interface ImageProps {
  content: ImageContent;
}

const Image: FC<ImageProps> = ({ content }) => {
  const { url, alt } = content;

  return (
    <div className="tips-modal__media-wrapper">
      <img src={url} alt={alt} className="img-fluid tips-modal__media-image" />
    </div>
  );
};

export default Image;
